import { isPathEqualOrSubpath, isSamePath } from "shared/utils/UrlUtils";

export const isCurrentWizardPage = (
  basePath: string,
  pagePath: string,
  currentPath: string,
) =>
  pagePath === basePath
    ? isSamePath(pagePath, currentPath)
    : // subpath match is to support child pages within a single wizard step,
      // e.g. for <PageTabs>
      isPathEqualOrSubpath(pagePath, currentPath);
